import { IDashboardMetadata } from '../dashboard-metadata.service';
import { USER_APPROVAL_COLUMNS } from './shared-dashboard.config';
import { BpSetupDashboardFiltersComponent } from '../filters/bp-setup/bp-setup-dashboard-filters.component';

export const BP_PROFILE_COLUMNS = [
  {
    name: 'Deconid'
  },
  {
    name: 'Delname'
  },
  {
    name: 'Defname'
  },
  {
    name: 'Delogdt'
  },
  {
    name: 'Decomnm'
  },
  {
    name: 'Rbcomnm'
  },
  {
    name: 'Decounm'
  },
  {
    name: 'Detrast_ds'
  },
  {
    name: 'Detradt'
  },
  {
    name: 'Deacslc'
  },
  {
    name: 'Decredt'
  },
  {
    name: 'Deregdt'
  },
  {
    name: 'Decreus'
  },
  {
    name: 'Decommt'
  },
  {
    name: 'History'
  }
];

export const BP_SETUP_KPI_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'New BP Setup KPI',
  filterComponent: {
    name: BpSetupDashboardFiltersComponent
  },
  mapping: {
    Decounm: 'country.id',
    Desprnm: 'customer.id',
    Deconti: 'geography.name',
    Rbcomnm: 'bpRequestedBy.id',
    Rbrqbty: 'bpRequestedByCompanyType.id'
  },
  reports: [
    {
      id: 257,
      key: 'OTHER_USERS_WITHOUT_COMPANY',
      comments:
        'Users waiting for full and legal company name',
      fixedFilters: {
        Decrety_ds: 'SIGNUP',
        Destate_ds: 'WAIT_APRVL',
        Decredt_FROM: '01/01/2018',
        Kpi: 'OTHERS_WITHOUT_COMPANY',
        Dashboard: 'BP'
      },
      mapping: {
        Owlname: 'arm.id'
      },
      columns: USER_APPROVAL_COLUMNS
    },

    {
      id: 257,
      key: 'OTHER_USERS_WITH_INACTIVE_BP_TO_BE_APPROVED',
      comments:
        'Company is set up on GA, BP operational = No, waiting for INTEL to approve users',
      fixedFilters: {
        Decrety_ds: 'SIGNUP',
        Destate_ds: 'WAIT_APRVL',
        Decredt_FROM: '01/01/2018',
        Kpi: 'OTHERS_WITH_INACTIVE_BP',
        Dashboard: 'BP'
      },
      mapping: {
        Owlname: 'arm.id'
      },
      columns: USER_APPROVAL_COLUMNS
    },

    {
      browselistCode: 'USERS',
      key: 'BP_PROFILE_INCOMPLETE',
      mapping: {
        Degbdmn: 'arm.id'
      },
      fixedFilters: {
        Demanba: '0',
        Decovst_ds: 'SETUP',
        Deregis: 1,
        Decmtds: 'P',
        Deactds: null
      },
      columns: BP_PROFILE_COLUMNS
    },

    {
      browselistCode: 'USERS',
      key: 'BP_PROFILE_COMPLETE',
      mapping: {
        Degbdmn: 'arm.id'
      },
      fixedFilters: {
        Demanba: '1',
        Decovst_ds: 'SETUP',
        Deregis: 1,
        Decmtds: 'P',
        Deactds: null
      },
      columns: BP_PROFILE_COLUMNS
    },

    {
      browselistCode: 'USERS',
      key: 'BP_IN_TRAINING',
      mapping: {
        Degbdmn: 'arm.id'
      },
      fixedFilters: {
        Bpoperational: 1,
        Decovst_ds: 'TRAINING',
        Decmtds: 'P',
        Demanba: '1',
        Deactds: null
      },
      columns: BP_PROFILE_COLUMNS
    },

    {
      id: 175,
      key: 'OPERATIONAL_BPS',
      mapping: {
        Gblname: 'arm.id',
        Derqbco: 'bpRequestedBy.id',
        Derqbty: 'bpRequestedByCompanyType.id'
      },
      fixedFilters: {
        Derqbbl: 'not'
      },
      columns: [
        {
          name: 'Pacomnm'
        },
        {
          name: 'Decounm'
        },
        {
          name: 'Detotlo'
        },
        {
          name: 'Denrusr'
        },
        {
          name: 'Desprnm'
        },
        {
          name: 'Desprst_ds'
        },
        {
          name: 'Derqbco'
        },
        {
          name: 'Losprst_ds'
        },
        {
          name: 'Lostaco'
        },
        {
          name: 'Improdt'
        },
        {
          name: 'Icprodt'
        },
        {
          name: 'Odlname'
        }
      ]
    },

    {
      browselistCode: 'TICKET',
      key: 'BP_SETUP_TICKETS',
      fixedFilters: {
        Demntty: '@NEWBP@@COVERAGE@'
      },
      mapping: {
        Shsprnm: 'customer.id',
        Shcounm: 'country.id',
        Arm_name: 'arm.id'
      },
      columns: [
        {
          name: 'Deagebd'
        },
        {
          name: 'Demndid'
        },
        {
          name: 'Delstbd'
        },
        {
          name: 'Decount'
        },
        {
          name: 'Shlslna'
        },
        {
          name: 'Rbcomnm'
        },
        {
          name: 'Shmtyds'
        },
        {
          name: 'Shdescr'
        },
        {
          name: 'Shcommt'
        },
        {
          name: 'Deaddco'
        }
      ]
    },

    {
      id: 74,
      key: 'NON_OPERATIONAL_BPS',
      fixedFilters: {
        Deopera_ds: 0,
        Dehaspr: null,
        Wvcurce: null,
        Deactif: null,
        Decovst_ds: '@BPLAMONLY@,@FULL@,@INVOICETO@,@ISSUES@,@SEMI@,@SETUP@,@TRAINING@,@VIRTUAL@'
      },
      mapping: {
        Desprid: 'customer.id',
        Degbdmn: 'arm.id'
      },
      columns: [
        {
          name: 'Decovst_ds',
          groupingSequence: 1
        },
        {
          name: 'Rbcomnm'
        },
        {
          name: 'Decomnm',
          aggregate: 'cnt'
        },
        {
          name: 'Decounm'
        },
        {
          name: 'Decodnm'
        },
        {
          name: 'Decredt'
        }
      ]
    }
  ]
};